import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { WebsiteTable } from '../global';
import { baseApi } from '../components/api';

export const fetchData = createAsyncThunk('website/fetchData', async () => {
  const response = await axios.get(baseApi + '/admin/website');
  return response.data.data;
});

export const createOrUpdateData = createAsyncThunk(
  'website/createOrUpdateData',
  async (data: any) => {
    await axios.post(baseApi + '/admin/website', data);
    return data;
  }
);

export const deleteData = createAsyncThunk('website/deleteData', async (id: number) => {
  await axios.delete(baseApi + `/admin/website/${id}`);
  return id;
});
interface WebsiteSlice {
    apiData: WebsiteTable[];
    status: string;
    counter: number; // Local state example
}
const websiteSlice = createSlice({
  name: 'website',
  initialState: {
    apiData: [],
    status: 'idle',
    counter: 0, // Initialize counter state
  } as WebsiteSlice,
  reducers: {
    // Reducer for incrementing the counter
    incrementCounter: (state) => {
      state.counter += 1;
    },
    // Reducer for decrementing the counter
    decrementCounter: (state) => {
      state.counter -= 1;
    },
    // Reducer for resetting the counter
    resetCounter: (state) => {
      state.counter = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.fulfilled, (state, action) => {
        state.apiData = action.payload;
        state.status = 'succeeded';
      })
      .addCase(createOrUpdateData.fulfilled, (state, action) => {
        state.apiData = action.payload;
      })
      .addCase(deleteData.fulfilled, (state, action) => {
        state.apiData = state.apiData.filter((item: any) => item.id !== action.payload);
      });
  },
});
// Export actions for counter
export const { incrementCounter, decrementCounter, resetCounter } = websiteSlice.actions;
export default websiteSlice.reducer;
